@if(isLoading) {
  <div class="d-flex flex-column justify-content-center align-items-center w-100 flex-grow-1">
    <span class="spinner-border"></span>
  </div>
} @else if (!complianceRequirementItems.length) {
  <div class="d-flex flex-column justify-content-center align-items-center w-100 flex-grow-1">
    <app-empty-state></app-empty-state>
  </div>
} @else {
  <div class="compliance-overview-details-container">
    <div
      class="compliance-list"
      infiniteScroll
      [scrollWindow]="false"
      [infiniteScrollDistance]="2"
      [infiniteScrollThrottle]="300"
      (scrolled)="onScrollDown()">
      @for(item of complianceRequirementItems; track item.requirementId) {
        <div class="compliance-container" (click)="viewComplianceAssets(item)">
        <div class="compliance-item">
          <div>
            <label class="compliance-name">{{ item.requirementName }}</label>
          </div>
          <div>
            <span>
              <svg width="16" height="16" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                <circle cx="9" cy="9" r="2.5" fill="#9FA1A4" fill-rule="evenodd"/>
              </svg>
            </span>
            <label class="compliance-type">{{ item.complianceName }}</label>
          </div>
          <div class="compliance-status-count">
            <app-compliance-status-indicator 
              [complianceItem]="item">
            </app-compliance-status-indicator>
          </div>
        </div>
        <div class="compliance-asset-count">
          <label> {{ 'compliance.overview.details.assetCount' | transloco: { count: item.assetCount } }} </label>
        </div>
      </div>
      }
    </div>

    @if(isLoadingMore) {
      <div class="loading-more">
        <span class="spinner-border"></span>
      </div>
    }
  </div>
}